var map = {
	"./apps/apps.module": [
		"./src/app/apps/apps.module.ts",
		"common",
		"apps-apps-module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"common",
		"authentication-authentication-module"
	],
	"./dashboards/dashboard.module": [
		"./src/app/dashboards/dashboard.module.ts",
		"common",
		"dashboards-dashboard-module"
	],
	"./starter/starter.module": [
		"./src/app/starter/starter.module.ts",
		"starter-starter-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;